/**
 * Meta color aliases for normalizing product color labels to SCSS class names.
 *
 * The keys are normalized forms of color names (English + Norwegian variants),
 * and the values must match the keys in the $item-colors Sass map in:
 *   Styles/global/modules/item-color.scss
 *
 * KEEP IN SYNC: When you add or modify colors in $item-colors in item-color.scss,
 * update this map to include the new color key and any English/Norwegian aliases
 * that should map to it.
 *
 * Example: If you add "svøm": #123456 to $item-colors, add entries here:
 *   "svøm": "svøm",
 *   "swim": "svøm" (if English alias needed)
 */
const META_COLOR_ALIASES: Record<string, string> = {
  blue: "bla",
  bla: "bla",
  green: "gronn",
  gronn: "gronn",
  gron: "gronn",
  red: "rod",
  rod: "rod",
  white: "hvit",
  hvit: "hvit",
  gray: "gra",
  grey: "gra",
  gra: "gra",
  black: "svart",
  svart: "svart",
  orange: "oransje",
  oransje: "oransje",
  pink: "rosa",
  rosa: "rosa",
  purple: "lilla",
  lilla: "lilla",
  brown: "brun",
  brun: "brun",
  yellow: "gul",
  gul: "gul",
};

export const normalizeMetaColorToCssKey = (
  metaColor?: string | null,
): string => {
  if (!metaColor) {
    return "";
  }

  const normalized = metaColor
    .trim()
    .toLowerCase()
    .replace(/æ/g, "ae")
    .replace(/ø/g, "o")
    .replace(/å/g, "a")
    .normalize("NFD")
    .replace(/[\u0300-\u036f]/g, "")
    .replace(/[^a-z]/g, "");

  return META_COLOR_ALIASES[normalized] ?? normalized;
};

export const getMetaColorClassName = (
  metaColor?: string | null,
): string | null => {
  const key = normalizeMetaColorToCssKey(metaColor);

  if (!key) {
    return null;
  }

  return `item-color--${key}`;
};
